export default __webpack_public_path__ + "static/media/arrow-pre.b4480ec9.svg";